<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card>
      <h1>{{ $t("Address") }}</h1>
      <form name="staff_form" method="post" v-on:submit.prevent="$event.preventDefault()">
        <div class="vx-row">
          <!-- required -->
          <div class="vx-col w-full mt-5">
            <label class="vs-input--label"
              >{{ $t("AddressLink") }} <span class="red">*</span></label
            >
            <b-form-input
              size="lg"
              :placeholder="$t('AddressLink')"
              v-validate="{ required: true }"
              :data-vv-as="$t('AddressLink')"
              name="link"
              v-model="link"
              class="w-full"
              @keydown.enter="checkForm"
            >
            </b-form-input>
            <span class="text-danger text-sm" v-show="errors.has('link')">{{
              errors.first("link")
            }}</span>
          </div>

          <div class="vx-col w-full mt-5">
            <label class="vs-input--label"
              >{{ $t("Address") }} <span class="red">*</span></label
            >
            <b-textarea
              v-validate="{ required: true }"
              v-model="address"
              rows="2"
              name="address"
              :data-vv-as="$t('Address')"
              :placeholder="$t('Address')"
            ></b-textarea>
            <span class="text-danger text-sm" v-show="errors.has('address')">{{
              errors.first("address")
            }}</span>
          </div>

          <!-- =================== -->
          <div class="vx-col w-full mt-8">
            <label class="vs-input--label">{{ $t("Map") }}</label>
            <span class="red">*</span><br />
            <img :src="url" class="mr-8 rounded mt-1" width="85px" />
            <input
              ref="uploadDocumentInput"
              type="file"
              v-validate="{
                required: image_required && url.includes('default_upload.d4c75de8.png'),
                size: 2048,
              }"
              class="hidden"
              accept="image/*"
              name="Map"
              id="map"
              :data-vv-as="$t('Map')"
              @change="selectedFile"
            />

            <b-button
              variant="primary"
              class="mr-4 mb-4 mt-2"
              size="lg"
              @click="$refs.uploadDocumentInput.click()"
              >{{ $t("Upload") }}</b-button
            >
            <br />
            <span class="text-danger text-sm" v-show="errors.has('Map')">{{
              errors.first("Map")
            }}</span>
          </div>
        </div>

        <div class="vx-col" id="update">
          <b-button
            type="filled"
            @click.prevent="submitForm"
            class="mt-5 block border-primary"
            variant="primary"
            >{{ $t("Submit") }}</b-button
          >
          <router-link :to="'/company/dashboard'">
            <b-button
              id="cancel"
              type="border"
              variant="border"
              class="mt-5 br-20 pl-5 pr-5 border-primary text-primary"
            >
              {{ $t("Cancel") }}
            </b-button>
          </router-link>
        </div>
      </form>
    </b-card>
  </b-overlay>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Cookies from "js-cookie";

// For custom error message
import { Validator } from "vee-validate";

export default {
  components: {
    FormWizard,
    TabContent,
  },
  data() {
    return {
      address: "",
      map: "",
      link: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      image_required: true,
      url: require("@/assets/images/portrait/small/default_upload.png"),
      images: null,
      document: "",
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  created() {
    let id =
      this.$store.getters.roles == "assistant"
        ? this.$store.getters.currentUser.company_id
        : this.$store.getters.currentUser.id;
    this.getMaps(id);
    this.loadLocale(this.$i18n.locale);
  },
  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addMapAddress();
        }
      });
    },

    selectedFile(event) {
      this.error = "";
      var filePath = event.target.files[0].name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.error =
          this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
            ? this.$t(error.replace(/[\s\/]/g, ""))
            : error;
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
        $("#map").val("");
      } else {
        this.images = event.target.files[0];
        this.url = URL.createObjectURL(this.images);
      }
    },
    /**
     *  addstaffs method for add record in a staff list
     **/
    addMapAddress() {
      let image = this.document || null;
      let map = this.images || image.document;
      this.show = true;
      let id =
        this.$store.getters.roles == "assistant"
          ? this.$store.getters.currentUser.company_id
          : this.$store.getters.currentUser.id;
      var data = new FormData();
      data.append("address", this.address);
      data.append("address_link", this.link);
      data.append("company_id", id);
      data.append("map", map);
      this.$store
        .dispatch("MapAddress", data)
        .then((res) => {
          this.show = false;
          this.$store.getters.currentUser.is_address_set = true;
          Cookies.set("currentUser", this.$store.getters.currentUser);
          this.$router.push("/company/settings/address").catch(() => {});

          this.$toasted.show(this.$t("AddressUpdated"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error("File : Add.vue | Function : mapAddress() | Error :", error);
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     *  getstaffs method get all companies from company list
     **/

    getMaps() {
      this.show = true;
      this.$store
        .dispatch(
          "GetMaps",
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id
        )
        .then((res) => {
          this.show = false;
          let response = res.data.data;
          var address_data = response;
          this.address = address_data.address;
          this.link = address_data.address_link;
          this.document = address_data.map_image;
          this.url = address_data.map_image.path;
        })
        .catch((error) => {
          this.$log.error("File : List.vue | Function : getMaps() | Error :", error);
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>
<style lang="stylus">
#department {
  margin-top: 20px;
}
</style>
<style lang="stylus">
#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}
</style>
